module.exports = __webpack_public_path__ + "img/changed-logo.1d1ea631.png";